import React, { useState, useEffect } from "react";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Chip from "@material-ui/core/Chip";
import moment from "moment";
import API from "../../actions";
import { getDKDateTimeText } from "../../libs/dktime";

const StyledTableCell = withStyles(theme => ({
    head: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white
    },
    body: {
        fontSize: 14
    }
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
    root: {
        "&:nth-of-type(odd)": {
            backgroundColor: theme.palette.background.default
        }
    }
}))(TableRow);

const useStyles = makeStyles({
    selectedChip: {
        backgroundColor: "#4d5ccc !important",
        color: "#fff !important"
    },
    chip: {
        "&:hover": {
            backgroundColor: "#4d5ccc !important",
            color: "#fff !important"
        }
    },
    table: {
        minWidth: 700
    }
});

export default props => {
    const classes = useStyles();
    const [selectedTime, setSelectedTime] = useState(null);
    const [rows, setRows] = useState([[], [], [], [], [], [], []].map(row => ({ key: Math.random(), data: [] })));

    useEffect(() => {
        (async () => {
            const qwe = await API.clientGetAvailable(
                props.treatment.therapistId,
                moment(props.date).valueOf(),
                moment(props.date).add(7, "days").valueOf(),
                props.treatment.duration * 1000,
                props.treatment.pause * 1000
            );
            const d = [[], [], [], [], [], [], []];
            qwe.flat().forEach(time =>
                d[moment(time).weekday()].push({
                    time: moment(time).format("HH:mm:ss"),
                    dktime: getDKDateTimeText(time)
                })
            );
            setRows(d.map(row => ({ key: Math.random(), data: row })));
        })();
    }, [props.date, props.treatment]);

    return (
        <TableContainer component={Paper}>
            <Table className={classes.table} aria-label="customized table">
                <TableHead>
                    <TableRow>
                        {["Mandag", "Tirsdag", "Onsdag", "Torsdag", "Fredag", "Lørdag", "Søndag"].map((day, i) => (
                            <StyledTableCell key={day} align="center">
                                {day} <br /> {moment(props.date).add(i, "day").format("D/M")}
                            </StyledTableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    <StyledTableRow>
                        {rows.map((row, i) => {
                            const selectedDate = moment(props.date).add(i, "day").format("YYYY-MM-DD");

                            return (
                                <StyledTableCell key={row.key} align="center">
                                    <div style={{ display: "flex", flexDirection: "column", alignSelf: "flex-start" }}>
                                        {row.data.map((dt, i) => {
                                            const isSelected = selectedTime === dt.time;
                                            return (
                                                <Chip
                                                    key={dt.time}
                                                    variant={isSelected ? "filled" : "outlined"}
                                                    label={dt.time + (dt.dktime || "")}
                                                    style={{ margin: "5px 0 5px 0", cursor: "pointer" }}
                                                    className={`${classes.chip} ${
                                                        isSelected ? classes.selectedChip : ""
                                                    }`}
                                                    onClick={() => {
                                                        // full ISO string
                                                        setSelectedTime(dt.time);
                                                        props.handleTimeClick(dt.time, selectedDate, i);
                                                    }}
                                                />
                                            );
                                        })}
                                    </div>
                                </StyledTableCell>
                            );
                        })}
                    </StyledTableRow>
                </TableBody>
            </Table>
        </TableContainer>
    );
};
